<template>
  <div>
    <v-card>
      <v-container>
        <v-card-title>Display Label Keys</v-card-title>
        <v-container fluid>
          <v-row>
            <v-col>
              <v-switch v-model="switch1" @change="displayKey" label="Display Keys"></v-switch>
              <span> For Example: '{{ $t('Extended_Over_180_Message') }}'</span>
            </v-col>
          </v-row>
        </v-container>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import i18next from 'i18next'
export default {
  name: 'TranslationSettings',
  data() {
    return {
      switch1: false
    }
  },
  methods: {
    displayKey: async function() {
      if (this.switch1) {
        await i18next.changeLanguage('cn')
      } else {
        await i18next.changeLanguage('en')
      }
    }
  }
}
</script>

<style scoped></style>
